import { createMuiTheme } from '@material-ui/core/styles'
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import createPalette from '@material-ui/core/styles/createPalette'
import typography from './typography'
import overrides from './overrides'
import palette from './palette'
import breakpoints from './breakpoint'

const themeBreakpoints = createBreakpoints(breakpoints)
const themePalette = createPalette(palette)

const MuiTheme = createMuiTheme({
  palette: palette,
  breakpoints: breakpoints,
  typography: typography(themeBreakpoints),
  overrides: overrides(themePalette)
})

export default MuiTheme
